import React, { useEffect, useState } from 'react'
import SelectFactura from '../../moleculas/Selects/SelectFactura/SelectFactura'
import GrillaAdjuntoFactura from '../GrillaAdjuntos/GrillaAdjuntoFactura.jsx'
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import SelectTipoDocumento from '../Selects/SelectTipoDocumento/SelectTipoDocumento.jsx'
import { useDispatch, useSelector } from 'react-redux'
import { addDocumentos, addFiles, resetDocumentos } from '../../../redux/facturaSlice.js'
import { mostrarTipoFactura } from '../../../helpers/funciones.js'
import { mostrarMensaje, useMostrarMensajeConfirmacion } from "../../../helpers/mensajeria"
import { Boton, Label, InputDate, Input, Spinner, SubTitulo } from "asocomponents"
import BuscadorJuicios from '../Buscadores/BuscadorJuicios/BuscadorJuicios.jsx';
import SelectPrestador from '../Selects/SelectPrestador/SelectPrestador.jsx';
import SelectEtapa from '../Selects/SelectEtapa/SelectEtapa.jsx';
import LiquidacionService from '../../../../modules/Liquidacion/application/LiquidacionService.js';
import { useNavigate } from "react-router-dom"
import { EstadosFacturaLiquidacion } from '../../../const/constantes.js';
import { MENSAJESAPP } from "../../../const/constantes.js";

function FormularioAltaFactura() {
    const navigate = useNavigate()
    const mostrarMensajeConfirmacion = useMostrarMensajeConfirmacion()

    const idFactura = useSelector(state => state.rootReducer.datosFactura.idFactura)

    const documentosCargados = useSelector(state => state.rootReducer.datosFactura.documentos)
    const fileCargados = useSelector(state => state.rootReducer.datosFactura.files)

    const usuarioString = sessionStorage.getItem("usuario") && JSON.parse(sessionStorage.getItem("usuario"))
    const cuit = usuarioString.usuario

    const dispatch = useDispatch()
    const MySwal = withReactContent(Swal);

    const [isOpen, setIsOpen] = useState(false)
    const [fechaFactura, setFechaFactura] = useState(null);
    const [tipoComprobante, setTipoComprobante] = useState(null);
    const [idPrestador, setIdPrestador] = useState(null);
    const [nroFactura, setNroFactura] = useState(null);
    const [etapa, setEtapa] = useState(null);
    const [estadoFactura, setEstadoFactura] = useState(null);
    const [caratulaJuicio, setCaratulaJuicio] = useState(null);

    const [ptoVenta, setPtoVenta] = useState(null);
    const [importe, setImporte] = useState(null);
    const [idJuicio, setIdJuicio] = useState(null)
    const [motivoRechazo, setMotivoRechazo] = useState(null)
    const [idEstadoFactura, setIdEstadoFactura] = useState(null)
    const [cuitPrestador, setCuitPrestador] = useState(null)
    const [fechaAproboRechazo, setFechaAproboRechazo] = useState()

    const [isLoading, setIsLoading] = useState(false)
    const [tipoComprobanteValido, setTipoComprobanteValido] = useState(false);
    const [fechaFacturaValido, setFechaFacturaValido] = useState(false);
    const [idJuicioValido, setIdJuicioValido] = useState(false);
    const [nroFacturaValido, setNroFacturaValido] = useState(false);
    const [ptoVentaValido, setPtoVentaValido] = useState(false);
    const [facturaAdjuntaValido, setFacturaAdjuntaValidado] = useState(false);
    const [importeValido, setImporteValido] = useState(false);
    const [idPrestadorValido, setIdPrestadorValido] = useState(false);
    const [etapaValido, setEtapaValido] = useState(false);
    const [documentacionValida, setDocumentacionValida] = useState(false);
    const [resetKey, setResetKey] = useState(0);

    const [formEnviado, setFormEnviado] = useState(false);

    const formValido = fechaFacturaValido && idJuicioValido && idJuicioValido && idPrestadorValido && etapaValido && nroFacturaValido && ptoVentaValido && facturaAdjuntaValido && importeValido && tipoComprobanteValido && documentacionValida;

    const agregarDocumentoAdjunto = (tipo, doc, name) => {

        const maxIndice = documentosCargados.length > 0
            ? Math.max(...documentosCargados.map(doc => doc.indice))
            : 0;

        const nuevoDocumento = {
            Sector: MENSAJESAPP.DOCDIGITALIZADOS.SECTORFACTURAJUICIO,
            Autor: usuarioString ? cuit : MENSAJESAPP.DOCDIGITALIZADOS.AUTORFACTURAJUICIO,
            Identifier: 0,
            indice: maxIndice + 1,
            tipo: tipo,
            tipoDescripcion: mostrarTipoFactura(tipo),
            nombre: name
        };

        dispatch(addDocumentos(nuevoDocumento))
        dispatch(addFiles(doc))
    }

    const validarTipoArchivo = (file) => {
        const tipoArchivo = file.type === 'application/pdf'
        const extensionArchivo = file.name.endsWith('.pdf')
        return !(tipoArchivo && extensionArchivo)
    }
    
    const completarCerosPtoVta = (event) => {
        const valor = event.target.value
        setPtoVenta(valor.toString().padStart(4, '0'))
    }

    const completarCerosNroFac = (event) => {
        const valor = event.target.value
        setNroFactura(valor.toString().padStart(8, '0'))
    }

    const redireccionar = () => {
        navigate("/facturas")
    }

    const limpiarForm = () => {
        setFechaFactura(null)
        setFechaFacturaValido(false)
        setImporte('')
        setImporteValido(false)
        setPtoVenta('')
        setPtoVentaValido(false)
        setNroFactura('')
        setNroFacturaValido(false)
        setIdJuicio('')
        setIdJuicioValido(false)
        setTipoComprobante(null)
        setTipoComprobanteValido(false)
        setEtapa(-2)
        setEtapaValido(false)
        setIdPrestador(-2)
        setIdPrestadorValido(false)
        dispatch(resetDocumentos())
    }


    const cargarInfoFactura = async () => {
        setIsOpen(true)
        const facturaService = new LiquidacionService()
        const factura = await facturaService.obtenerFacturaLiquidacion(idFactura, cuit)

        if (factura) {
            setNroFacturaValido(true)
            setPtoVentaValido(true)
            setImporteValido(true)
            setFechaFacturaValido(true)
            setIdPrestadorValido(true)
            setEtapaValido(true)
            setIdJuicioValido(true)
            setTipoComprobanteValido(true)

            //Seteo los valores en los campos obtenidos desde la base por el IdFactura
            setEstadoFactura(factura.estado)
            setFechaFactura(factura.fechaFacFormateada)
            setEtapa(factura.codigoEtapaFacturacion)
            setPtoVenta(factura.nroFactura.toString().substring(0, 4))
            setNroFactura(factura.nroFactura.toString().substring(5, 12))
            setImporte(factura.importe)
            setTipoComprobante(factura.idTipoFactura)
            setIdPrestador(factura.idLetradoCiaPrestador)
            setCaratulaJuicio(factura.caratulaJuicio)
            setIdJuicio(factura.idJuicio)
            setMotivoRechazo(factura.motivoRechazo)
            setIdEstadoFactura(factura.idEstadoFactura)
            setFechaAproboRechazo(factura.fechaAproboRechazo)
        }

        setIsOpen(false)
    }

    const handleFechaFactura = (fecha) => {
        if (fecha !== "") {
            if (Date.parse(fecha) > Date.now()) {
                setFechaFactura("")
                setResetKey(prev => prev + 1)
                setFechaFacturaValido(false)
                mostrarMensaje(MENSAJESAPP.VALIDACIONES.FECHAFACTURA, "error", 2000)
            } else {
                setFechaFacturaValido(true)
                setFechaFactura(fecha)
            }
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true)

        const nFactura = ptoVenta + '-' + nroFactura
        const serviceLiquidacion = new LiquidacionService()

        //Valido si el numero de factura existe o no cargada
        const existeFactura = await serviceLiquidacion.validarFactura(nFactura, cuitPrestador)

        if (!existeFactura) {
            const factura = {
                "nroFactura": nFactura,
                "fechaFactura": fechaFactura,
                "idTipoComprobante": tipoComprobante,
                "idLetradoCiaPrestador": idPrestador,
                "idJuicio": idJuicio,
                "importe": importe,
                "etapaFacturacion": etapa,
                "idusuarioExterno": usuarioString && usuarioString.idusuario,
                "documentos": documentosCargados
            }
            const resultado = await serviceLiquidacion.guardarFactura(factura, fileCargados)

            if (resultado) {
                setFormEnviado(prev => !prev);
                mostrarMensaje(MENSAJESAPP.CONFIRMACION.FACTURAENVIADAOK, "success", 3000)
            }
            else
                mostrarMensaje(MENSAJESAPP.ERRORES.FACTURANOENVIADA, "error", 3000)
        }
        else
            mostrarMensaje(MENSAJESAPP.ERRORES.FACTURAYAEXISTENTE, "error", 3000)

        setIsLoading(false)
    };

    const handleTipoComprobante = (event) => {
        const valor = event.target.value
        if (valor !== '')
            setTipoComprobanteValido(true)
        else
            setTipoComprobanteValido(false)

        setTipoComprobante(valor)
    }

    const handlePtoVenta = (valor) => {
        if (valor !== '' && valor > 0)
            setPtoVentaValido(true)
        else
            setPtoVentaValido(false)
        setPtoVenta(valor)
    }

    const handleEtapa = (event) => {
        const valor = event.target.value

        if (valor !== '') {
            setEtapaValido(true)
        }
        else
            setEtapaValido(false)

        setEtapa(valor)
    }

    const handleNroFactura = (valor) => {
        if (valor !== '' && valor > 0)
            setNroFacturaValido(true)
        else
            setNroFacturaValido(false)

        setNroFactura(valor)
    }

    const handlePrestador = (event) => {
        const valor = event.target.value
        if (valor > 0) {
            setIdPrestador(valor)
            setIdPrestadorValido(true)

            const prestadorSeleccionado = event.target.options[event.target.selectedIndex].text;
            const cuit = prestadorSeleccionado.split(' - ')[0]
            setCuitPrestador(cuit)
        }
        else
            setIdPrestadorValido(false)

    }

    const handleImporte = (valor) => {
        if (valor !== '')
            setImporteValido(true)
        else
            setImporteValido(false)

        setImporte(valor)
    }

    const handleJuicio = async (juicio) => {
        if (juicio) {
            setIdJuicio(juicio.idJuicio)
            setIdJuicioValido(true)
        }
        else
            setIdJuicioValido(false)
    }

    const handleCancelar = () => {
        mostrarMensajeConfirmacion(MENSAJESAPP.CONFIRMACION.CANCELARCARGA, redireccionar, "info")
    }

    const handleVolver = () => {
        redireccionar()
    }


    const handleButtonClick = () => {
        let tempTipoDocumento = '';
        let tempFile = null;

        etapa ?
            MySwal.fire({
                title: 'Adjuntar archivo a la factura',
                html: (
                    <>
                        <div className='flex flex-col justify-center items-center text-xs mb-5 font-semibold'>
                            En caso de subir un solo archivo .pdf con toda la documental requerida, utilizar el item "Factura".
                        </div>
                        <div className='flex flex-col justify-center items-center mb-5'>
                            <SelectTipoDocumento width="w-44" onChange={(e) => tempTipoDocumento = e.target.value} etapa={etapa} />
                        </div>
                        <div className='flex flex-col justify-center items-center'>
                            <input type="file" accept=".pdf" onChange={(e) => tempFile = e.target.files[0]} className="p-1 pr-2 text-gray-900 sm:text-xs focus:ring-blue-500 focus:border-blue-500 mr-3" />
                        </div>
                    </>
                ),
                width: '600px',
                showCancelButton: true,
                confirmButtonColor: "#EB0045",
                cancelButtonColor: "#6B7280",
                confirmButtonText: 'Adjuntar',
                cancelButtonText: 'Cancelar',
                preConfirm: async () => {
                    if (!tempTipoDocumento) {
                        Swal.showValidationMessage(MENSAJESAPP.DOCDIGITALIZADOS.SELEECCIONARTIPODOCUMENTO);
                        return false;
                    }
                    if (!tempFile || validarTipoArchivo(tempFile)) {
                        Swal.showValidationMessage(MENSAJESAPP.DOCDIGITALIZADOS.SELEECCIONARTIPODOCUMENTOPDF);
                        return false;
                    }
                    //const base64File = await convertFileToBase64(tempFile);
                    return { tipoDocumento: tempTipoDocumento, file: tempFile, name: tempFile.name };
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    // Maneja la lógica después de la confirmación
                    agregarDocumentoAdjunto(result.value.tipoDocumento, result.value.file, result.value.name)
                }
            })
            :
            mostrarMensaje(MENSAJESAPP.DOCDIGITALIZADOS.SELECCIONARETAPA, "info", 4000)
    }

    useEffect(() => {
        const result = documentosCargados.find(doc => doc.tipo === "FCJ")
        result ? setFacturaAdjuntaValidado(true) : setFacturaAdjuntaValidado(false)

        //Valido la documentación seugn la etapa
        if (etapa === "I") {
            const resultDoc = documentosCargados.find(doc => doc.tipo === "CDJ")
            resultDoc ? setDocumentacionValida(true) : setDocumentacionValida(false)
        }
        else {
            //Si tiene la factura
            if (result)
                setDocumentacionValida(true)
            else
                setDocumentacionValida(false)
        }

    }, [etapa,documentosCargados])

    useEffect(() => {
        limpiarForm()
    }, [formEnviado])

    useEffect(() => {
        idFactura && cargarInfoFactura()
    }, [])

    return (
        <>
            <div>
                <div className="flex flex-row justify-left items-left mt-5 ml-20">
                    <Label texto="Ingrese los campos correspondientes y cargue los archivos digitales necesarios por los honorarios convenidos según la etapa que corresponda conforme convenio suscripto con la Cia." sizefont="text-lg" />
                </div>
            </div>
            <div className={`overlay ${isOpen ? "open" : ""}`}></div>
            <div className="flex flex-col justify-center items-center mt-5">
                <div className="border-asociart-blue w-[900px] shadow-lg">
                    <div>
                        <div className={`${estadoFactura === null ? '' : 'pointer-events-none'}`}>
                            {estadoFactura &&
                                <div className="flex flex-row justify-end items-end mt-5 ml-20">
                                    <SubTitulo titulo={`Estado: ${estadoFactura}`} />
                                </div>
                            }
                            <div className="flex flex-row justify-left items-left mt-5 ml-20">
                                <Label texto="Fecha Factura:" />
                                <InputDate width='w-40' onChange={handleFechaFactura} valor={fechaFactura} key={resetKey} />{!fechaFacturaValido && <Label texto="(*)" color="text-asociart-custom" />}
                                <SelectFactura width="w-64" onChange={handleTipoComprobante} valor={tipoComprobante} />{!tipoComprobanteValido && <Label texto="(*)" color="text-asociart-custom" />}
                            </div>
                            <div className="flex flex-row justify-left items-left mt-5 ml-20">
                                <Label texto="Prestador:" />
                                <SelectPrestador idLetrado={usuarioString && usuarioString.idusuario} valor={idPrestador} onChange={handlePrestador} width="w-60" todos={false} />{!idPrestadorValido && <Label texto="(*)" color="text-asociart-custom" />}
                                <Label texto="Etapa:" />
                                <SelectEtapa width="w-18" onChange={handleEtapa} valor={etapa} />{!etapaValido && <Label texto="(*)" color="text-asociart-custom" />}
                            </div>
                            <div className="flex flex-row justify-left items-left mt-5 ml-20">
                                <Label texto="Nro. Factura:" />
                                <Input type="number" placeholder="Pto. Vta" width='w-14' onChange={handlePtoVenta} valor={ptoVenta} maxlength="4" onBlur={completarCerosPtoVta} />
                                <Label texto="-" />
                                <Input type="number" placeholder="N° Factura" width='w-20' onChange={handleNroFactura} valor={nroFactura} maxlength="8" onBlur={completarCerosNroFac} />
                                {(!ptoVentaValido || !nroFacturaValido) && <Label texto="(*)" color="text-asociart-custom" />}
                                <div className='flex flex-row justify-left items-left ml-14'><Label texto="Monto:" />
                                    <Input type="number" placeholder="Total $" width='w-20' onChange={handleImporte} valor={importe} labelNumber={true} />{!importeValido && <Label texto="(*)" color="text-asociart-custom" />}
                                </div>
                            </div>
                            <div className="flex flex-row justify-left items-left mt-5 ml-20">
                                <Label texto="P. Judicial:" />
                                {!caratulaJuicio ? <BuscadorJuicios onChange={handleJuicio} cuitLetrado={cuit} width="w-42" valor={idJuicio} referente="administrativo" /> : <Label texto={caratulaJuicio} color="text-gray-600" />}{!idJuicioValido && <Label texto="(*)" color="text-asociart-custom" />}
                            </div>
                        </div>
                        <div className="flex flex-col justify-center items-center mt-5">
                            {!estadoFactura && <Boton texto="Adjuntar Archivos" fondo="rojo" onClick={handleButtonClick} />} 
                            <GrillaAdjuntoFactura idFactura={idFactura} />
                        </div>
                        {(idEstadoFactura === EstadosFacturaLiquidacion.RECHAZADA) &&
                            <div className="mx-auto w-[85%] p-4 mt-2">
                                <div className="flex flex-row items-start space-x-2">
                                    <Label texto="Motivo Rechazo: " />
                                    <Label texto={motivoRechazo} color="text-red-600" />
                                    <div className='flex flex-row ml-5'><Label texto="Fecha:" /><Label texto={fechaAproboRechazo} color="text-gray-600" />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {!estadoFactura &&
                        <div className="flex justify-between items-center w-full px-10 mt-5 mb-5">
                            {/* Botón Enviar centrado */}
                            <div className="flex-1 flex justify-end align-middle w-[55%]">
                                {isLoading ? (
                                    <Spinner color="red" size="20" />
                                ) : (
                                    <Boton
                                        texto="Enviar"
                                        fondo={formValido ? "rojo" : "gris"}
                                        onClick={handleSubmit}
                                        disabled={!formValido}
                                    />
                                )}
                            </div>

                            {/* Botón Cancelar a la derecha */}
                            <div className="flex justify-end align-middle w-[45%]">
                                <Boton
                                    texto="Cancelar carga"
                                    height="h-7"
                                    onClick={handleCancelar}
                                    fondo="gris"
                                />
                            </div>
                        </div>
                    }
                    {estadoFactura &&
                        <div className="flex justify-between items-center w-full px-10 mt-5 mb-5">
                            <div className="flex-1 flex justify-center align-middle">

                                <Boton
                                    texto="Volver"
                                    fondo="rojo"
                                    onClick={handleVolver}
                                />

                            </div>
                        </div>
                    }
                    {!estadoFactura &&
                        <div className="flex flex-row justify-end items-center m-5 text-sm">
                            <Label texto="(*) Campos obligatorios" color="text-asociart-custom" />
                        </div>
                    }
                    <div className="flex flex-row justify-start items-center m-5 text-xs">
                        Ante cualquier duda, comunicarse con su asistente administrativo de referencia (Pablo Monzón o Alejandro Villalba), según corresponda
                    </div>
                </div>
            </div>

        </>
    )
}

export default FormularioAltaFactura



